module.exports = __webpack_public_path__ + "img/6875.0b0482e2.png";